import EDHttp from '../utils/EDHttp';

export default
    {
        saveEin: function (payload)
        {
            return new Promise((resolve, reject) =>
            {
                EDHttp.post(`/ein/create/company/ein`, payload).then(result =>
                {
                    if (result && !result.data.error)
                        resolve(result.data.data);
                    else
                        reject('Error');
                }).catch(error => reject(error))

            })
        },
        getEins: function (domainId, page = 0)
        {
            return new Promise((resolve, reject) =>
            {
                EDHttp.get(`/ein/get-ein/company/${domainId}/${page}`).then(result =>
                {
                    if (result && !result.data.error)
                        resolve(result.data.data);
                    else
                        reject('Error');
                }).catch(error => reject(error))

            })
        },
        deleteEin: function (einId)
        {
            return new Promise((resolve, reject) =>
            {
                EDHttp.delete(`/ein/delete/company/ein/${einId}`).then(result =>
                {
                    if (result && !result.data.error)
                        resolve(result.data.data);
                    else
                        reject('Error');
                }).catch(error => reject(error))

            })
        },
        getTerminatedUsers: function (domainId, page = 0, params)
        {
            return new Promise((resolve, reject) =>
            {
                EDHttp.get(`/ein/terminated-users/company/${domainId}/${page}?order=${params?.order}&orderBy=${params?.orderBy}&search=${params?.search ?? ''}`).then(result =>
                {
                    if (result && !result.data.error)
                        resolve(result.data.data);
                    else
                        reject('Error');
                }).catch(error => reject(error))

            })
        },
        getExcludedUsers: async (domainId, page = 0, params) =>
        {
            try
            {
                const { data: result } = await EDHttp.get(`/ein/excluded-users/company/${domainId}/${page}?order=${params?.order}&orderBy=${params?.orderBy}`)
                return result.data
            } catch (error)
            {
                throw error.response.data.message
            }
        },
        removeTerminatedUser: async (userId, domainId, excludeUserFromCensus) =>
        {
            try
            {
                const { data: result } = await EDHttp.delete(`/ein/terminated-users/company/${domainId}/${userId}?excludeUserFromCensus=${excludeUserFromCensus}`)
                return result.data
            } catch (error)
            {
                throw error.response.data.message
            }

        },
        removeExcludedUser: async (userId, domainId) =>
        {
            try
            {
                const { data: result } = await EDHttp.delete(`/ein/excluded-users/company/${domainId}/${userId}`)
                return result.data
            } catch (error)
            {
                throw error.response.data.message
            }
        },
        addUserToCensusExclusionList: async (payload) =>
        {
            try
            {
                const { data: result } = await EDHttp.post(`/ein/excluded-users`, payload)
                return result.data
            } catch (error)
            {
                throw error.response.data.message
            }
        },
    }